import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '../../components/ui/PageHeader';
import { Segmented } from '../../components/ui/Segmented';
import { OrderHistory } from '../../features/orders/OrderHistory';
import { OrdersBoard } from '../../features/orders/OrdersBoard';
import { useOrdersLayout } from '../../features/orders/useOrdersLayout';
import { usePageTitle } from '../../hooks/usePageTitle';

type View = 'board' | 'table' | 'history';

/** /orders is the live orders (as a board or a table, remembered per user); /orders?view=history is the searchable archive. */
const OrderList = () => {
    const { t } = useTranslation('orders');
    usePageTitle(t('title'));
    const [params, setParams] = useSearchParams();
    const [layout, setLayout] = useOrdersLayout();
    const history = params.get('view') === 'history';
    const view: View = history ? 'history' : layout;

    const changeView = (next: View) => {
        if (next === 'history') {
            setParams({ view: 'history' }, { replace: true });
            return;
        }
        setLayout(next);
        setParams({}, { replace: true });
    };

    return (
        <div>
            <PageHeader
                title={t('title')}
                actions={
                    <Segmented
                        aria-label={t('views.label')}
                        value={view}
                        onChange={changeView}
                        options={[
                            { value: 'board', label: t('views.board') },
                            { value: 'table', label: t('views.table') },
                            { value: 'history', label: t('views.history') },
                        ]}
                    />
                }
            />
            {history ? <OrderHistory /> : <OrdersBoard layout={layout} />}
        </div>
    );
};

export default OrderList;
